import { Typography } from 'seagull';
import styles from "../ServicesSection.module.scss";
import { CreditDeleteButton } from "./CreditDeleteButton";
import CreditSwitch from "./CreditSwitch";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function CreditBillingItem(props) {
  const {
    name,
    costDisplay,
    id,
    isPaused,
    index,
    agreement,
    disabled,
    tooltipTitle,
    onRefresh
  } = props;
  return /*#__PURE__*/_jsxs("li", {
    "data-testid": "service-".concat(index),
    className: styles.serviceBox,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.serviceDescription,
      children: [/*#__PURE__*/_jsx(Typography, {
        "data-testid": "name",
        children: name
      }), /*#__PURE__*/_jsx("div", {
        className: styles.cost,
        children: /*#__PURE__*/_jsx(Typography, {
          "data-testid": "cost",
          variant: "paragraph2",
          skin: "secondary",
          children: costDisplay
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.lineItemAction,
      children: [/*#__PURE__*/_jsx(CreditSwitch, {
        "data-testid": "billing-control-credit-".concat(index, "-switch"),
        chargeId: id,
        agreementId: agreement.id,
        disabled: disabled,
        tooltipTitle: tooltipTitle,
        isPaused: isPaused,
        onRefresh: onRefresh
      }), /*#__PURE__*/_jsx(CreditDeleteButton, {
        chargeId: id,
        agreementId: agreement.id,
        disabled: disabled,
        tooltipTitle: tooltipTitle,
        onRefresh: onRefresh,
        "data-testid": "billing-control-credit-".concat(index, "-delete")
      })]
    })]
  });
}